/**
 * Solitaire — motion vocabulary.
 *
 * A playing card is a specific kind of object: flat, light, a little stiff.
 * It does not bounce like a ball or jiggle like jelly. It SLIDES across felt
 * and SETTLES with a tiny weighted overshoot, and it FLIPS along an edge (a
 * scaleX squash, never a 3D rotateY page-flip — flat planes can't sell that).
 *
 * These springs are tuned for that feel and are deliberately distinct from
 * Five's letterpress-tile springs.
 */

/** A card sliding to a new pile — quick, confident, a hair of settle. */
export const slideSpring = {
  type: 'spring' as const,
  stiffness: 540,
  damping: 40,
  mass: 0.72,
};

/** The deal cascade — cards arriving feel slightly lighter / livelier. */
export const dealSpring = {
  type: 'spring' as const,
  stiffness: 420,
  damping: 32,
  mass: 0.64,
};

/** A card lifting under the finger / on selection — a small, eager rise. */
export const liftSpring = {
  type: 'spring' as const,
  stiffness: 620,
  damping: 32,
  mass: 0.52,
};

/** The whole table composition settling in on entry. */
export const tableSpring = {
  type: 'spring' as const,
  stiffness: 210,
  damping: 26,
  mass: 1.05,
};

/** Hub cards. */
export const cardSpring = {
  type: 'spring' as const,
  stiffness: 250,
  damping: 27,
  mass: 0.9,
};

/** Hover lift on hub cards / buttons. */
export const hoverSpring = {
  type: 'spring' as const,
  stiffness: 380,
  damping: 24,
};

/** A gentle "can't go there" nudge — soft, never a hard rejection. */
export const nudgeSpring = {
  type: 'spring' as const,
  stiffness: 640,
  damping: 18,
};

/** The win cascade — cards fan out slow and luxurious, then settle. */
export const cascadeSpring = {
  type: 'spring' as const,
  stiffness: 150,
  damping: 22,
  mass: 1.1,
};

// ---------------------------------------------------------------------------
// Timing tokens (ms) — hand-tuned, all collapse to ~0 under reduced-motion.
// ---------------------------------------------------------------------------

/** Press feedback on a card / control. */
export const PRESS_MS = 90;
/** A card flipping face-up (the squash midpoint swaps the face). */
export const FLIP_MS = 280;
/** Stagger between cards as the deal cascades out. */
export const DEAL_STAGGER_MS = 34;
/** A card's travel time when moved by tap or drag. */
export const MOVE_MS = 240;
/** Stock → waste draw beat. */
export const DRAW_MS = 200;
/** Win cascade: time between each card peeling off into the fan. */
export const CASCADE_STAGGER_MS = 52;
/** Win cascade: how long one card's arc to its resting fan position takes. */
export const CASCADE_TRAVEL_MS = 900;
/** Beat before the win card rises after the cascade completes. */
export const WIN_CARD_DELAY_MS = 1500;
